import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import Button  from "../components/button/button";
import { Buffer } from "buffer";
import { Oval } from "react-loader-spinner";

// Import supabase configuration
import supabase from "../config/supabase";
import { loginUser, signupUser } from "../redux/actions/actions";
import mixpanel from 'mixpanel-browser';

function ClientLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
   
  }, []);

  const handleSubmit = async(e) => {
    e.preventDefault();
    setShowLoader(true);
    mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({email: email});
    if(data && data.length){
        dispatch(loginUser(email, password))
        .then(() => {
          mixpanel.track('Logged in',{
            'email':  email,
          });
          mixpanel.identify(data[0].id);
          mixpanel.people.set({
            $email: email,
            $name: email,
          });
          localStorage.setItem("loggedIn", true);
          
          setEmail('');
          setPassword('');

          let dash_id = Buffer.from(data[0].dashboard_id, "utf-8").toString("base64");
          let link = "dashboard=" + dash_id;
          localStorage.setItem("dashboard", link);
          navigate(`/clientBoard?${link}`);
          setShowLoader(false);
        })
        .catch(() => {
          setErrorMessage("Invalid email or password");
          console.log("Error");
          setShowLoader(false);
        });
    }
    else{
    setErrorMessage("You do not have access to this board");
    setShowLoader(false);
    }

  }
  
  return (
    <div className="w-full min-h-screen bg-blue-7">
        {showLoader && (
            <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
            {/* Add backdrop */}
            
                <div className={`relative flex`}>
                    <Oval
                    color="white"
                    secondaryColor="grey"
                    height="40"
                    width="60"
                    />
                    <div className="flex items-center">Hold Tight-just getting this page ready.</div>
                </div>
            </div>
        )}
        <div className="flex justify-center ">
            
            <div className="w-[370px] md:w-[680px] min-h-screen bg-white-1 m-3 md:m-0 rounded md:rounded-none">

                <div className="px-5 md:px-32 py-14">
                    {/* logo */}
                    <img src="/clientlogo.svg" />

                    <div className="mt-14 flex justify-center">

                        <div>
                            {/* Add text */}
                            <div className="text-[40px] font-medium">Client Login</div>

                            {/* Login form */}
                            <form className='mt-8 md:mt-5 grid grid-cols-12 gap-3' onSubmit={handleSubmit}>
                                <input 
                                type="email" 
                                name="email" 
                                className="w-[300px] h-[50px] md:w-[400px] md:h-[56px] border border-black-1 bg-white-1 text-black-1 col-span-12 rounded-sm placeholder-black-1 pl-5"
                                placeholder='Email' 
                                required
                                value={email}
                                onClick={() => setErrorMessage("")}
                                onChange={(e) => {
                                setEmail(e.target.value);
                                }}/>

                                <input 
                                type="password" 
                                name="Password" 
                                className="w-[300px] h-[50px] md:w-[400px] md:h-[56px] mt-4 border border-black-1 bg-white-1 text-black-1 col-span-12 rounded-sm placeholder-black-1 pl-5"
                                placeholder='Password' 
                                required
                                value={password}
                                onClick={() => setErrorMessage("")}
                                onChange={(e) => setPassword(e.target.value)}
                                />

                                <div className="col-span-12 flex justify-between mt-1">
                                    <div >
                                        <input type="checkbox" id="remeberMe" name="remember" style={{width:"15px",height:"15px",radius:"1px"}}/>
                                        <label htmlFor="remeberMe" className="text-[14px] ml-1.5 ">Remember me</label>
                                    </div>

                                    {/* <div className="flex justify-end text-blue-8 text-[14px]">
                                        Forgot password?
                                    </div> */}
                                    
                                </div>

                                { errorMessage && <div className='col-span-12 text-red-1'>{errorMessage}</div> }
                                
                                <Button
                                type="submit"
                                buttonType="primary"
                                className='w-[300px] h-[50px] md:w-[400px] md:h-[56px] mt-2 col-span-12 bg-blue-8'
                                value="Login"
                                />
                            </form>

                            <div className="mt-20 text-center md:text-left">© Copyright 2010 - 2022 Gaper</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}
export default ClientLogin;
